/* import __COLOCATED_TEMPLATE__ from './indent.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();